import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { Select } from 'foundations-components/transitional/components/Select';
import isNumber from 'transmute/isNumber';
import { hasNewIlsTimeFiltersEnabled, hasRemoveTimezoneForDates } from '../../permissions/gates';
import TimezoneToggle from './TimezoneToggle';
import FilterOperatorType from '../propTypes/FilterOperatorType';
import { getDefaultTimezoneWithoutOptionality } from '../../utils/timezoneUtils';
import { DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import GreaterRolling from 'customer-data-filters-ui/filterQueryFormat/operator/GreaterRolling';
import LessRolling from 'customer-data-filters-ui/filterQueryFormat/operator/LessRolling';
import UpdateDateFilterWithTimezonesNotification from './UpdateDateFilterWithTimezonesNotification';
import getConditionId from '../../utils/getConditionId';
import { FlexDateInputWithTimezoneWrapper } from '../../constants/inlineLayout';
import TimezoneDropdown from './TimezoneDropdown';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import LessRollingWithOrWithoutYear from '../../filterQueryFormat/operator/LessRollingWithOrWithoutYear';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class FilterOperatorRollingInequalityInput extends PureComponent {
  constructor(props) {
    super(props);
    this.handleUpdateClick = () => {
      const {
        condition,
        onChange
      } = this.props;
      if (!condition) {
        return;
      }
      this.setState({
        showTimezoneToggle: false
      });
      onChange(syntheticEvent(condition.set('zoneId', I18n.moment.portalTz().tz())), {
        hasClickedUpdate: true
      });
    };
    this.handleChangeTimezone = useUTC => {
      const {
        condition,
        onChange
      } = this.props;
      onChange(syntheticEvent(condition.set('zoneId', useUTC ? 'UTC' : I18n.moment.portalTz().tz())));
    };
    this.handleChangeDirection = ({
      target: {
        value: direction
      }
    }) => {
      const {
        condition,
        onChange
      } = this.props;
      onChange(syntheticEvent(condition.set('direction', direction)));
    };
    this.handleChangeNumberOfDays = ({
      target: {
        value: days
      }
    }) => {
      const {
        condition,
        onChange
      } = this.props;
      this.setState({
        error: false
      });
      onChange(syntheticEvent(condition.set('numberOfDays', days)));
    };
    this.handleCommit = value => {
      if (!isNumber(value)) {
        this.setState({
          error: true
        });
        return '';
      }
      return `${value}`;
    };
    const {
      condition: _condition,
      getDefaultTimezone,
      getIsUngated,
      onChange: _onChange,
      hideExtraInputs
    } = props;
    const defaultTimezone = getDefaultTimezone(_condition.field);
    this.state = {
      error: false,
      showTimezoneToggle: !hideExtraInputs
    };
    if (hasNewIlsTimeFiltersEnabled(getIsUngated) && defaultTimezone && !_condition.zoneId) {
      _onChange(syntheticEvent(_condition.set('zoneId', defaultTimezone)));
    }
  }
  setShowTimezoneToggle() {
    const {
      condition,
      getIsUngated,
      hideExtraInputs
    } = this.props;
    const {
      hasTimezones,
      field: fieldRecord
    } = condition;
    const isDateTimeOperator = fieldRecord && fieldRecord.type === DATE_TIME;
    if (hasRemoveTimezoneForDates(getIsUngated) && !isDateTimeOperator && !hasTimezones && (condition.constructor === GreaterRolling || condition.constructor === LessRolling || condition.constructor === LessRollingWithOrWithoutYear)) {
      this.setState({
        showTimezoneToggle: false
      });
    } else {
      this.setState({
        showTimezoneToggle: !hideExtraInputs
      });
    }
  }
  componentDidMount() {
    this.setShowTimezoneToggle();
  }
  componentDidUpdate() {
    this.setShowTimezoneToggle();
  }
  render() {
    const {
      condition,
      disabled,
      getDefaultTimezone,
      getIsUngated,
      getTimezoneOptions,
      inputUse,
      readOnly,
      useOnePanel
    } = this.props;
    const {
      showTimezoneToggle,
      error
    } = this.state;
    const {
      hasTimezones,
      field: fieldRecord
    } = condition;
    const isDateTimeOperator = fieldRecord && fieldRecord.type === DATE_TIME;
    const defaultTimezone = hasRemoveTimezoneForDates(getIsUngated) && !hasTimezones ? getDefaultTimezoneWithoutOptionality(fieldRecord) : getDefaultTimezone(fieldRecord);
    const zoneId = condition.zoneId || defaultTimezone;
    const useUTC = zoneId === 'UTC';
    const options = [{
      text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorRollingInequalityInput.daysAgo', {
        count: condition.numberOfDays || 0
      }),
      value: 'backward'
    }, {
      text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorRollingInequalityInput.daysFromNow', {
        count: condition.numberOfDays || 0
      }),
      value: 'forward'
    }];
    const InputWrapper = useOnePanel ? FlexDateInputWithTimezoneWrapper : 'div';
    const TimezoneSelector = useOnePanel ? TimezoneDropdown : TimezoneToggle;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(InputWrapper, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Box, {
            grow: 1,
            children: /*#__PURE__*/_jsx(FormControl, {
              error: error,
              validationMessage: error ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "customerDataFiltersUI.customerDataFilters.FilterOperatorRollingInequalityInput.error"
              }) : null,
              children: /*#__PURE__*/_jsx(NumberInput, {
                defaultValue: 1,
                disabled: disabled,
                formatter: this.handleCommit,
                min: 0
                // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                ,
                onChange: this.handleChangeNumberOfDays,
                readOnly: readOnly,
                use: inputUse,
                value: condition.numberOfDays
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Select, {
              buttonUse: "transparent",
              disabled: disabled,
              onChange: this.handleChangeDirection,
              options: options,
              readOnly: readOnly,
              value: condition.direction
            })
          })]
        }), showTimezoneToggle && condition.zoneId && /*#__PURE__*/_jsx(TimezoneSelector, {
          conditionId: getConditionId(condition),
          timezoneOptions: getTimezoneOptions(condition.field),
          fieldType: condition.field ? condition.field.get('type') : undefined,
          useUTC: useUTC,
          onChange: this.handleChangeTimezone,
          getIsUngated: getIsUngated
        })]
      }), hasRemoveTimezoneForDates(getIsUngated) && showTimezoneToggle && !isDateTimeOperator && /*#__PURE__*/_jsx(UpdateDateFilterWithTimezonesNotification, {
        onUpdateClick: this.handleUpdateClick,
        useUTC: useUTC
      })]
    });
  }
}
FilterOperatorRollingInequalityInput.propTypes = {
  condition: FilterOperatorType.isRequired,
  disabled: PropTypes.bool,
  inputUse: PropTypes.oneOf(['on-dark']),
  onChange: PropTypes.func.isRequired,
  getDefaultTimezone: PropTypes.func.isRequired,
  getTimezoneOptions: PropTypes.func.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
export default FilterOperatorRollingInequalityInput;